import { isInternalOrdersManager } from './isInternalOrdersManager';

export type ResetInspectionSampleUser = {
	is_superuser?: boolean;
	groups?: Array<string | { name?: string | null } | null | undefined> | null;
};

const QC_LEAD_GROUP_RE = /^quality control lead$/i;

function groupName(group: string | { name?: string | null } | null | undefined): string {
	return typeof group === 'string' ? group : (group?.name ?? '');
}

/** True when the API will accept POST /inspection-samples/:id/reset/.
 *  Mirrors `CanResetInspectionSample`: superuser, Quality Control Lead, or Shop Manager. */
export const canResetInspectionSample = (
	user: ResetInspectionSampleUser | null | undefined,
): boolean =>
	!!user &&
	(isInternalOrdersManager(user) ||
		(user.groups ?? []).some((g) => QC_LEAD_GROUP_RE.test(groupName(g))));

export default canResetInspectionSample;
